import React from "react";
import {
    Card,
    CardContent,
    CardMedia,
    Typography,
    Avatar,
    Button, IconButton, Divider,
    TextField, List, ListItem, ListItemAvatar, ListItemText,
    Dialog, DialogTitle, DialogContent
} from "@material-ui/core";

import {arrayFilter, buildShapperPath, choiceImage, isResponsive, parserContent} from "../../../helpers/Tools";
import BreadCrumbs from "../../../components/BreadCrumbs";
import FlatList from 'flatlist-react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {compose} from 'redux';
import {withTranslation} from 'react-i18next';
import OpenItem from "../../../helpers/OpenItem";
import { useState } from "react";

import {baseApiUrl, uploadMediaStatic} from "../../../api/api";
import {store} from "../../../store/store";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBackward,
    faComment,
    faGrinHearts,
    faPaperPlane,
    faThumbsUp, faWindowClose
} from "@fortawesome/free-solid-svg-icons";
import {FormulaireDynamicPicture} from "../../Formulaire/FormulaireDynamic/Formulaire.Dynamic.Picture";
import ImageUploader from "./ImageUploader";

class SocialFeed extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            posts: [],
            open: false,
            comments: [],
            commentText: '',
            like: '',
            selectedImage: null,
            selectedImageUrl: null,
        };
    }
    async componentDidMount() {
        let posts = await this.fetchSocialPosts().then(
            (response) => {
                console.log("response");
                console.log(response);

                this.setState({ posts: response });

                return response;
            }
        ).catch((error) => {
            console.error('Erreur lors de la récupération des posts:', error);
        });
    }
    render() {
        const dyn_string = this.props.t

        //* Récupération de la liste des posts sociaux */
        //get posts state loaded in componentDidMount
        const { dataPage } = this.props;
        const posts = this.state.posts;

        const handleNewPost = async () => {
            console.log("handleNewPost");

            //open newPostForm dialog
            this.setState({ openNewPost: true });

        };

        const handleNewPostClose = () => {
            this.setState({openNewPost: false });
        }


        const avatarUrl = buildShapperPath(store.getState().profil.mobinaute.media_url);

        //bouton nouveau post
        const newPostButton = (
        <div style={{ display: "flex", alignItems: "center", marginBottom: 10, width: "100%",maxWidth: "800px", marginLeft: "auto", marginRight: "auto", marginTop: "20px", backgroundColor: "#f5f5f5", color: "#fff"
            , center: "center", justifyContent: "center", borderRadius: "5px", padding: "20px 20px" }} onClick={handleNewPost}>
            <Avatar alt="Profile" style={{ width: 40, height: 40, marginRight: 10 }} src={avatarUrl} />
            <TextField
                fullWidth
                variant="outlined"
                placeholder={dyn_string('g_label_message')}
                sx={{ marginLeft: 2 }}
            />
            <IconButton
                color="primary"
                disabled={true}
                sx={{ marginLeft: 2 }}
            >
                <FontAwesomeIcon icon={faPaperPlane} />
            </IconButton>
        </div>

        );

        const handleImageSelected = async (file) => {
            this.setState({selectedImage: file});
            console.log('Fichier image sélectionné:', file);
            // Tu pourrais ici l’envoyer vers un backend
            // go upload
            const responseUploadMediaStatic = await uploadMediaStatic(file);
            console.log('responseUploadMediaStatic:', responseUploadMediaStatic);

            if (responseUploadMediaStatic.success) {
                this.setState({selectedImageUrl: responseUploadMediaStatic.result.file_url});
            } else {
                console.error('Erreur lors de l\'upload de l\'image:', responseUploadMediaStatic.error);
            }
        };

        const newPostForm = (
            <Dialog open={this.state.openNewPost} onClose={handleNewPostClose} fullWidth maxWidth="sm">
                <IconButton
                    onClick={handleNewPostClose}
                    style={{ position: "absolute", top: 10, right: 10, color: "#3f51b5" }}
                >
                    <FontAwesomeIcon icon={faWindowClose} />
                </IconButton>
                <DialogTitle>{dyn_string('g_label_new_post')}</DialogTitle>
                <DialogContent>
                    <TextField
                        margin="dense"
                        id="message"
                        label={dyn_string('g_label_message')}
                        multiline={true}
                        rows={4}
                        type="text"
                        fullWidth
                        variant="outlined"
                    />

                    <ImageUploader onImageSelected={handleImageSelected} />


                    <Button
                        variant="contained"
                        color="primary"
                        onClick={async () => {
                            //handleNewPost
                            //const title = document.getElementById("name").value;
                            const title = "";
                            const message = document.getElementById("message").value;
                            const image = this.state.selectedImageUrl || null;

                            //call uploadMediaStatic webservice

                            await this.handleNewPost({
                                title: title,
                                message: message,
                                image: image
                            });

                            //refresh posts
                            let posts = await this.fetchSocialPosts().then(
                                (response) => {
                                    console.log("response");
                                    console.log(response);

                                    this.setState({ posts: response });

                                    return response;
                                }
                            ).catch((error) => {
                                console.error('Erreur lors de la récupération des posts:', error);
                            });



                            this.setState({ openNewPost: false });
                        }}
                        style={{ marginTop: "20px", width: "100%", maxWidth: "800px", marginLeft: "auto", marginRight: "auto", backgroundColor: "#3f51b5", color: "#fff"
                            , center: "center", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px 20px" }}
                    >
                        {dyn_string('g_label_post')}
                    </Button>
                </DialogContent>
            </Dialog>
        );

        if (isResponsive()) {
            return (
                <div>
                    <BreadCrumbs id={this.props.dataPage.id} style={{marginBottom: "20px"}}/>
                    {newPostButton}
                    {newPostForm}
                <ul style={{
                    padding: 0,
                    listStyle: "none",
                    gridTemplateColumns: "repeat(auto-fill, minmax(400px, 1fr))",
                    paddingInlineStart: "20px",
                    paddingInlineEnd: "20px"
                }}>
                    <FlatList
                        list={posts}
                        renderItem={this.renderCategory}
                        renderWhenEmpty={() => <h4
                            style={{marginTop: "70px", textAlign: "center"}}>{dyn_string('g_label_no_result')}</h4>}
                        display={{
                            grid: false,
                            gridGap: "20px",
                        }}
                        style={{listStyle: "none", backgroundColor: '#ffffff', marginTop: "20px", padding: 0}}
                    />
                </ul>
                </div>
            );
        } else {
            return (
                <div>
                    <BreadCrumbs id={this.props.dataPage.id} style={{marginBottom: "20px"}}/>
                    {newPostButton}
                    {newPostForm}
                    <ul style={{
                        gridTemplateColumns: "repeat(auto-fill, minmax(400px, 1fr))",
                        paddingInlineStart: "20px",
                        paddingInlineEnd: "20px"
                    }}>
                        <FlatList
                            list={posts}
                            renderItem={this.renderCategory}
                            renderWhenEmpty={() => <h4
                                style={{marginTop: "70px", textAlign: "center", backgroundColor: '#ffffff'}}>{dyn_string('g_label_no_result')}</h4>}
                            display={{
                                grid: false,
                                gridGap: "40px",
                            }}
                        />
                    </ul>
                </div>
            );
        }
    }

    renderCategory = (tile, key) => {

        console.log("renderCategory");

        const [expanded, setExpanded] = useState(false);
        const [open, setOpen] = useState(false);
        const [openFullImage, setOpenFullImage] = useState(false);

        const [comments, setComments] = useState([]);
        const [commentText, setCommentText] = useState('');
        const [like, setLike] = useState('');

        let state = store.getState();

        const handleClose = () => setOpen(false);

        let text = tile.content;


        let textFormated = text.replace(/(\r\n|\n|\r)/gm, "<br/>");
        //catch urls
        let regExUrl = /((https?:\/\/)|(www\.))([a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=]+)/gim;
        textFormated = textFormated.replace(regExUrl, function (url) {
            let newUrl = url;
            if (!url.startsWith("http")) {
                newUrl = "http://" + url;
            }
            return `<a href="${newUrl}" target="_blank">${url}</a>`;
        });

        //const prenomnom = tile.prenom + " " + tile.nom;
        const prenomnom = tile.author.firstname + " " + tile.author.lastname;
        //const timeAgo = tile.timeAgo;
        //"publish_date": "2025-03-24 12:09:00",
        const publish_date = tile.created_at;
        const date = new Date(publish_date);
        const timeAgo = date.toLocaleDateString('fr-FR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });

        const handleOpen = async () => {
            setOpen(true);
            try {
                const response = await fetch(baseApiUrl + '/getInteractionsByContentId', {
                    method: 'POST', // Requête POST, comme dans le curl
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams({
                        'appId': state.application.getApp.id,
                        'mobinauteId': parseInt(state.profil.mobinaute.id, 10),
                        'contentId': tile.id, // ID du contenu
                        'offset': '0',
                        'limit': '100'
                    })
                });

                const data = await response.json();

                if (!data.success) {
                    throw new Error('Erreur lors de la récupération des commentaires');
                }


                const comments = data.result.comments;

                console.log(comments);

                setComments(comments); // Assurez-vous que `data` contient les commentaires sous la forme attendue
            } catch (error) {
                console.error('Erreur lors du chargement des commentaires:', error);
            }
        };

        const handleLike = async () => {
            setLike(true);
            try {
                const response = await fetch(baseApiUrl + '/setInteractionForContentId', {
                    method: 'POST', // Méthode POST
                    body: new URLSearchParams({
                        'appId': state.application.getApp.id,
                        'mobinauteId': parseInt(state.profil.mobinaute.id, 10),
                        'contentId': tile.id, // ID du contenu
                        'type': 'reaction', // Type d'interaction
                        'value': "1" //
                    })
                });

                const data = await response.json();

                //refresh posts
                let posts = await this.fetchSocialPosts().then(
                    (response) => {
                        console.log("response");
                        console.log(response);

                        this.setState({ posts: response });

                        return response;
                    }
                ).catch((error) => {
                    console.error('Erreur lors de la récupération des posts:', error);
                });

                if (!data.success) {
                    throw new Error('Erreur lors du like');
                }
            } catch (error) {
                console.error('Erreur lors du chargement des commentaires:', error);
            }
        };

        const handleSubmitComment = async (commentText) => {
            try {
                const response = await fetch(baseApiUrl + '/setInteractionForContentId', {
                    method: 'POST', // Méthode POST
                    body: new URLSearchParams({
                        'appId': state.application.getApp.id,
                        'mobinauteId': parseInt(state.profil.mobinaute.id, 10),
                        'contentId': tile.id, // ID du contenu
                        'type': 'comment', // Type d'interaction
                        'value': commentText // Le texte du commentaire
                    })
                });

                if (!response.ok) {
                    throw new Error('Erreur lors de l\'envoi du commentaire');
                }

                const data = await response.json();
                console.log('Commentaire envoyé avec succès:', data);
                // Réinitialiser le champ de texte du commentaire
                setCommentText('');
                // Optionnellement, tu peux recharger les commentaires après avoir ajouté un nouveau commentaire
                handleOpen(); // Récupère les nouveaux commentaires après l'envoi
            } catch (error) {
                console.error('Erreur lors de l\'envoi du commentaire:', error);
            }
        };

        console.log("tile");
        console.log(tile);

        const handleImageClick = () => {
            setOpenFullImage(true);
        };

        const handleImageClose = () => {
            setOpenFullImage(false);
        };

        return (
                <Card key={key} style={{ margin: "auto", borderRadius: 3, boxShadow: 3, marginTop: "30px", width: "100%", maxWidth: 800 }}>
                    {/* Bouton de retour */}
                    {/* Header */}
                    <CardContent sx={{ display: "flex", alignItems: "center" }}>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginLeft: "auto" }}>
                            <Avatar src={buildShapperPath(tile.author.profilMedia)} alt="Profile" sx={{ width: 56, height: 56, mr: 2 }} />
                            <div style={{ paddingLeft: 15 }}>
                                <Typography variant="h6" sx={{ mr: 1 }}>{prenomnom}</Typography>
                                <Typography variant="body2" color="textSecondary">{timeAgo}</Typography>
                            </div>
                        </div>
                    </CardContent>


                    {/* Contenu */}

                    <CardContent>
                        {/* Titre et sous-titre */}
                        <Typography variant="h5" gutterBottom>{tile.title}</Typography>

                        {/* Texte de publication */}
                        <Typography variant="body1" paragraph>
                            {!expanded && text.length > 200 ? text.substring(0, 200) + '...' : parserContent(textFormated)}
                        </Typography>
                        {!expanded && text.length > 200 && (
                            <Button onClick={() => setExpanded(true)} color="primary">Voir plus</Button>
                        )}
                    </CardContent>


                    {/* Image d'illustration */}

                    {tile.media_url &&
                        <CardMedia component="img" image={buildShapperPath(tile.media_url)} alt="Illustration" style={{ padding : 10, maxHeight: 400, cursor: "pointer" }} onClick={handleImageClick} />
                    }

                    <Divider />

                    {/* Boutons */}
                    <CardContent style={{ display: "flex", justifyContent: "space-around", padding: "4px" }}>
                        <IconButton color="primary" onClick={handleLike}>
                            <FontAwesomeIcon icon={faThumbsUp} />
                            <Typography className="ml-2">
                                J'aime ({tile.nb_likes})
                            </Typography>

                        </IconButton>
                        <IconButton color="primary" onClick={handleOpen}>
                            <FontAwesomeIcon
                                icon={faComment}
                            />

                            <Typography className="ml-2">
                                Commentaires ({tile.nb_comments})
                            </Typography>
                        </IconButton>
                    </CardContent>
                    {/* Section des commentaires */}
                    {/* Popup de commentaires */}
                    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
                        <IconButton
                            onClick={handleClose}
                            style={{ position: "absolute", top: 10, right: 10, color: "#3f51b5" }}
                            >
                            <FontAwesomeIcon icon={faWindowClose} />
                        </IconButton>
                        <DialogTitle>Commentaires</DialogTitle>
                        <DialogContent>
                            <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                                <Avatar src={buildShapperPath(state.profil.mobinaute.media_url)} alt="Profile" style={{ width: 40, height: 40, marginRight: 10 }} />
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Écrire un commentaire..."
                                    value={commentText}
                                    onChange={(e) => setCommentText(e.target.value)}
                                    sx={{ marginLeft: 2 }}
                                />
                                <IconButton
                                    color="primary"
                                    onClick={() => handleSubmitComment(commentText)}
                                    disabled={!commentText.trim()}
                                    sx={{ marginLeft: 2 }}
                                >
                                    <FontAwesomeIcon icon={faPaperPlane} />
                                </IconButton>
                            </div>


                            {/* Liste des commentaires */}
                            <List>
                                {comments.map((comment, index) => (
                                    <ListItem key={index} alignItems="flex-start">
                                        <ListItemAvatar>
                                            <Avatar src={comment.avatar} alt={comment.lastname} />
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={comment.firstname + ' ' + comment.lastname}
                                            secondary={comment.commentaire}
                                        />
                                        <Typography variant="body2" color="textSecondary">
                                            {new Date(comment.createdAt).toLocaleDateString('fr-FR', {
                                                year: 'numeric',
                                                month: '2-digit',
                                                day: '2-digit',
                                                hour: '2-digit',
                                                minute: '2-digit'
                                            })}
                                        </Typography>
                                    </ListItem>
                                ))}
                            </List>
                        </DialogContent>
                    </Dialog>

                    <Dialog open={openFullImage} onClose={handleImageClose} maxWidth="lg">
                        <DialogContent>
                            <img
                                src={tile.media_url ? buildShapperPath(tile.media_url) : ''}
                                alt="Illustration agrandie"
                                style={{ width: "100%", height: "auto" }}
                            />
                        </DialogContent>
                    </Dialog>
                </Card>
        );
    }

    fetchSocialPosts = async () => {
        const state = store.getState();

        let token = '';
        if (typeof state.profil.mobinaute.accounts !== 'undefined' && typeof state.profil.mobinaute.accounts.shapper_token !== 'undefined') {
            token = state.profil.mobinaute.accounts.shapper_token.access_token;
        } else if (typeof state.application.deviceToken !== 'undefined') {
            token = state.application.deviceToken.access_token;
        }

        const response = await fetch(baseApiUrl + '/getSocialPosts', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${token}`,
            },
            body: new URLSearchParams({
                'contentId': this.props.dataPage.id,
            })
        });

        const data = await response.json();

        console.log("getSocialPosts");

        console.log(data);

        console.log(data.success);

        console.log(data.result);

        if (!data.success) {
            throw new Error('Erreur lors de la récupération des posts');
        }


        return data.result || [];

    };

    handleNewPost = async (post) => {
        console.log("handleNewPost");
        console.log(post);
        //send post to api
        const state = store.getState();

        let token = '';
        if (typeof state.profil.mobinaute.accounts !== 'undefined' && typeof state.profil.mobinaute.accounts.shapper_token !== 'undefined') {
            token = state.profil.mobinaute.accounts.shapper_token.access_token;
        } else if (typeof state.application.deviceToken !== 'undefined') {
            token = state.application.deviceToken.access_token;
        }

        let body = new URLSearchParams({
            'contentId': this.props.dataPage.id,
            'title': post.title,
            'content': post.message
        });

        if (post.image) {
            body.append('mediaUrl', post.image);
        }

        const response = await fetch(baseApiUrl + '/sendSocialPost', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${token}`,
            },
            body: body

        });
        const data = await response.json();
        console.log("sendSocialPost");
        console.log(data);
        console.log(data.success);
        if (!data.success) {
            throw new Error('Erreur lors de l\'envoi du post');
        }
        else {
            console.log("Post envoyé avec succès");
            this.setState({selectedImage: null, selectedImageUrl: null});
        }
        return data.result || [];

    }
}

// send form new post



const mapStateToProps = (props) => ({
    styles: props.style,
    posts: props.posts || [],

});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {},
        dispatch
    );

export default compose(withTranslation(), connect(mapStateToProps, mapDispatchToProps()))(SocialFeed);
